module.exports = __webpack_public_path__ + "static/investor-preview-1-e0d46e6bb87dcd94814248a89dabd7c5.jpg";